import { CONTROL_BAR_BROADCAST } from './broadcastConfig'

/** 默认单帧停留（未配置 dwellMs 时的兜底） */
const DEFAULT_DWELL_MS = 3000
const SCOPE_DEFAULT_DWELL_MS = 4000

/**
 * 取当前应参与轮播的 slide 列表（enabled !== false）。
 * @param {typeof CONTROL_BAR_BROADCAST} [config]
 */
export function getActiveBroadcastSlides(config = CONTROL_BAR_BROADCAST) {
  return (config.slides || []).filter((slide) => slide.enabled !== false)
}

/**
 * 是否应在控制条 idle 态启动轮播：无筛选且无行勾选。
 */
export function shouldRunBroadcast({ hasActiveScopeFilters, hasRowSelection }) {
  return !hasActiveScopeFilters && !hasRowSelection
}

/**
 * 是否值得启动轮播：除 scope-default 外至少还有一条 release-note。
 * 仅一条时直接静态展示，避免无意义切换动画。
 */
export function shouldUseCarousel(slides) {
  if (!slides || slides.length <= 1) {
    return false
  }
  const releaseNotes = slides.filter((s) => s.type === 'release-note')
  return releaseNotes.length > 0
}

/**
 * 读取单帧停留毫秒数；scope-default 未配 dwellMs 时略长于普通帧。
 */
export function getSlideDwellMs(slide, config = CONTROL_BAR_BROADCAST) {
  if (slide.dwellMs != null && slide.dwellMs > 0) {
    return slide.dwellMs
  }
  if (slide.type === 'scope-default') {
    return SCOPE_DEFAULT_DWELL_MS
  }
  return config.defaultDwellMs || DEFAULT_DWELL_MS
}
